var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9819_5920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0892 4.01026L10.5852 3.51526C10.9602 3.14032 11.4689 2.92969 11.9992 2.92969C12.5295 2.92969 13.0381 3.14032 13.4132 3.51526L20.4842 10.5853C20.6701 10.771 20.8177 10.9916 20.9183 11.2344C21.019 11.4772 21.0708 11.7374 21.0708 12.0003C21.0708 12.2631 21.019 12.5233 20.9183 12.7661C20.8177 13.0089 20.6701 13.2295 20.4842 13.4153L13.4142 20.4853C13.2284 20.6712 13.0079 20.8187 12.7651 20.9194C12.5223 21.02 12.262 21.0718 11.9992 21.0718C11.7364 21.0718 11.4761 21.02 11.2333 20.9194C10.9905 20.8187 10.7699 20.6712 10.5842 20.4853L3.51419 13.4153C3.32823 13.2295 3.18071 13.0089 3.08007 12.7661C2.97942 12.5233 2.92761 12.2631 2.92761 12.0003C2.92761 11.7374 2.97942 11.4772 3.08007 11.2344C3.18071 10.9916 3.32823 10.771 3.51419 10.5853L7.04919 7.05026",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.72998V11.73",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.73V14.74",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9819_5920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTriangle);
export default __webpack_public_path__ + "static/media/white-triangle.766cb6f3a345a96219a3c38da5162318.svg";
export { ForwardRef as ReactComponent };